export default __webpack_public_path__ + "static/project_preference-6a47d7f8f2ad292ceaf06d6aeffa5b3d.jpeg";